<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本集名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入剧本集名称" disabled="" />
      </a-form-model-item>
      <a-form-model-item label="剧本集介绍" prop="introduction" >
        <a-input v-model="form.introduction" placeholder="请输入内容" type="textarea" disabled=""allow-clear />
      </a-form-model-item>
      <!--      <a-form-model-item label="所属用户id 外键user_user.id" prop="userId" >-->
      <!--        <a-input v-model="form.userId" placeholder="请输入所属用户id 外键user_user.id" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="用户昵称" prop="nickName" >
        <a-input v-model="form.nickName" placeholder="请输入用户昵称" disabled="" />
      </a-form-model-item>
      <a-form-model-item label="收藏数" prop="collectionNum" >
        <a-input v-model="form.collectionNum" placeholder="请输入收藏数" disabled=""/>
      </a-form-model-item>
      <a-form-model-item label="是否推荐" prop="isRecommend">
        <a-switch v-model="form.isRecommend" />{{ form.isRecommend ? '是' : '否' }}
      </a-form-model-item>
      <!--      <a-form-model-item label="逻辑删除标记，1：删除，0：未删除，默认0" prop="isDeleted" v-if="formType === 1">
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记，1：删除，0：未删除，默认0" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="乐观锁" prop="version" v-if="formType === 1">
        <a-input v-model="form.version" placeholder="请输入乐观锁" />
      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSheet, addSheet, updateSheet } from '@/api/script/sheet'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        introduction: null,

        userId: null,

        isRecommend: null,
        nickName: null,
        collectionNum: null,

        createTime: null,

        updateTime: null,

        creator: null,

        modifier: null,

        isDeleted: null,

        remark: null,

        version: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '剧本集名称不能为空', trigger: 'blur' }
        ],

        userId: [
          { required: true, message: '所属用户id 外键user_user.id不能为空', trigger: 'blur' }
        ],

        /* isRecommend: [
          { required: true, message: '是否推荐不能为空', trigger: 'blur' }
        ], */

        collectionNum: [
          { required: true, message: '收藏数不能为空', trigger: 'blur' }
        ],

        isDeleted: [
          { required: true, message: '逻辑删除标记，1：删除，0：未删除，默认0不能为空', trigger: 'blur' }
        ],

        version: [
          { required: true, message: '乐观锁不能为空', trigger: 'blur' }
        ]

      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: { ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,

        name: null,

        introduction: null,

        userId: null,

        isRecommend: null,

        collectionNum: null,

        createTime: null,

        updateTime: null,

        creator: null,

        modifier: null,

        isDeleted: null,

        remark: null,

        version: null

      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSheet(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSheet(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSheet(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
